
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { seeding_form_list } from './lib/form_struct';
import UserDefined from './component/user-defined.vue';
import BatchModifying from './component/batch-modifying.vue';
import { seeding_modifying_list } from './lib/modifying';
import moment from 'moment';

const getUrl = require('baimahu/url-with-param');
const dateFormat = require('bmh/date-format');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const Hundun = namespace('Hundun');
const API = {
  get_list: `${FCAPI}/boss/hundun/datacenter/user`,
  teacher_get_list: `${FCAPI}/boss/hundun/setting/teacher`,
  delete_tag: `${FCAPI}/boss/hundun/user/tag`,
  get_seeding_list: `${FCAPI}/boss/hundun/chuang/seeding`,
  edit_seeding_batch: `${FCAPI}/boss/hundun/chuang/seeding/batch/0`,
  edit_user_detail: `${FCAPI}/boss/hundun/user/attribute`,
  edit_custom_config: `${FCAPI}/boss/hundun/chuang/customconfig/0`,
  get_custom_config: `${FCAPI}/boss/hundun/chuang/customconfig`,
  seeding_type: `${FCAPI}/boss/hundun/chuang/seeding/type`,
  user_define: `${FCAPI}/boss/hundun/chuang/custom/`
};

@Component({
  components: { BatchModifying, UserDefined }
})
export default class MissionDetail extends Vue {
  /* eslint-disable */
  // @ts-ignore
  @Hundun.State('teacher_list') teacher_list: any; //负责班主任
  @Hundun.State('tag_list') tag_list: any; //标签
  @Watch('teacher_list')
  teacherListChange(newValue: string) {
    this.search_info_list.charge_teacher_id.options = newValue;
  }
  @Watch('tag_list')
  tagListChange(newValue: any) {
    // this.search_info_list.tag_id.bind.options = newValue.filter((item: any) => item.type == 1);
    // this.search_info_list.tag_id_chaung.bind.options = newValue.filter((item: any) => item.type == 2);
    // this.search_info_list.tag_id.bind.options;
  }
  search_info_list: any = seeding_form_list;
  btn_list: Array<any> = [
    { id: 1, label: '批量修改', type: 'primary' },
    { id: 2, label: '自定义表头', type: 'primary' },
    { id: 3, label: '导出', type: 'primary' },
    { id: 4, label: '搜索', type: 'primary' },
    { id: 5, label: '清空搜索条件', type: 'link' }
  ];

  data_list: Array<any> = [];
  select_row_key = [];
  pagenation_info = { current: 0, limit: 0, total: 0 };
  is_loading = false;
  modifying_dialog_visible = false;
  user_define_dialog_visible = false;
  dialog_form_list: any = JSON.parse(JSON.stringify(seeding_modifying_list));
  user_define_form_list: any = [];
  user_define_list: any = [];
  dialog_title = '';
  dialog_type = 0; // 弹窗类型 1 = 批量修改， 2 = 标签添加
  select_tag_id = 0;
  type_options = [];
  window = window as any;

  record = {} as any;
  show_text_modal = false;
  text = '';

  // 日期
  dateFormat = (time: number) => dateFormat(new Date(time * 1000), '%Y-%m-%d');
  // 格式化
  formatMobile = (phone: any) => {
    const reg = /^(\d{3})\d{4}(\d{4})$/;
    phone = phone.toString().replace(reg, '$1****$2');
    return phone;
  };
  // 表格数据
  async getSeedingList(page = 1) {
    this.is_loading = true;
    const custom_list = this.user_define_list
      .filter((item: any) => item.value)
      .map((item: any) => ({
        id: item.id,
        type: item.type == 1 ? 'text' : 'select',
        value: item.value || ''
      }));
    // const tag_id = this.search_info_list.tag_id.value;
    // const tag_id = this.search_info_list.tag_id.value;

    const send_data = {
      name: this.search_info_list.name.value,
      mobile: this.search_info_list.mobile.value,
      corp_name: this.search_info_list.corp_name.value,
      corp_position: this.search_info_list.corp_position.value,
      income_min: this.search_info_list.income.value.first,
      income_max: this.search_info_list.income.value.second,
      charge_teacher_id: this.search_info_list.charge_teacher_id.value.join(',') || undefined,
      online_status: this.search_info_list.online_status.value,
      // tag_id: tag_id ? tag_id.map((item: any) => item[item.length - 1]).join(',') : undefined,
      tag_id: this.getTagId().join(','),
      type_id: this.search_info_list.type.value,
      followup: this.search_info_list.followup.value,
      callback_time_start: this.search_info_list.callback_time.value[0] ? moment(this.search_info_list.callback_time.value[0]).startOf('days').unix() : undefined,
      callback_time_end: this.search_info_list.callback_time.value[1] ? moment(this.search_info_list.callback_time.value[1]).endOf('day').unix() : undefined,
      custom_list: encodeURIComponent(JSON.stringify(custom_list)),
      current: page,
      limit: 20
    };
    const res = await this.$axios.get(API.get_seeding_list, { params: send_data });
    if (res.status !== 200) return this.$message.error('列表数据获取失败！');
    this.pagenation_info = { current: res.data.data.current, limit: res.data.data.limit, total: res.data.data.total };
    this.data_list = res.data.data.detail;
    this.data_list.forEach((item) => {
      item['user_log'] = '';
      item.type_id = item.type_id == 0 ? undefined : item.type_id;
      const custom_list = this.user_define_list.map((element: any) => ({ channel: 1, customconfig_id: element.id, custom_value: undefined }));
      item.custom.forEach((element: any) => {
        custom_list.forEach((val: any) => {
          if (element.customconfig_id == val.customconfig_id) val.custom_value = element.custom_value;
        });
      });
      item.callback_time = item.callback_time ? moment(item.callback_time * 1000) : undefined;
      item.custom_list = custom_list;
    });
    this.is_loading = false;
  }
  getTagId = (): any[] => {
    const tag_arr: any[] = [];
    if (this.search_info_list.tag_id.value) {
      this.search_info_list.tag_id.value.forEach((element: any) => {
        tag_arr.push(element[element.length - 1]);
      });
    }
    if (this.search_info_list.tag_id_chuang.value) {
      this.search_info_list.tag_id_chuang.value.forEach((element: any) => {
        tag_arr.push(element[element.length - 1]);
      });
    }
    return tag_arr.filter((item: any) => item != undefined);
  }
  // 自定义表头数据
  async getCustomConfig() {
    const res = await this.$axios.get(API.get_custom_config, { params: { channel: 1 } });
    if (res.data.status !== 200) return this.$message.error('自定义表头获取失败！');
    this.user_define_form_list = res.data.data;
    this.user_define_form_list.forEach((element: any) => {
      element.options = [...element.options.split(',').map((item: any) => ({ value: item }))];
    });
    this.user_define_list = JSON.parse(JSON.stringify(this.user_define_form_list));
    this.user_define_list.forEach((item: any) => {
      item['value'] = undefined;
    });
  }

  async getSeedingType() {
    const res = await this.$axios.get(API.seeding_type, { params: { current: 1, limit: 9999 } });
    this.search_info_list.type.options = [{ id: 0, name: '全部' }, ...res.data.data.detail, { id: -1, name: '无' }];
    this.type_options = res.data.data.detail;
  }

  // 翻页
  paginationOption() {
    return {
      current: this.pagenation_info.current || 0,
      total: this.pagenation_info.total || 0,
      pageSize: this.pagenation_info.limit || 0,
      showTotal: () => `共${this.pagenation_info.total}条，每页${this.pagenation_info.limit}条`
    };
  }

  //添加标签
  addTag(record: any, type: number) {
    this.dialog_type = 2;
    this.dialog_title = '添加标签';
    this.select_tag_id = record.user_id;
    this.dialog_form_list = [
      {
        tag_name: 'a-cascader',
        key: 'tag',
        label: '标签',
        value: undefined,
        bind: {
          options: this.tag_list.filter((item: any) => item.type == type),
          fieldNames: { label: 'tag_name', value: 'id', children: 'parent' },
          changeOnSelect: true,
          placeholder: '请选择'
        }
      }
    ];
    this.modifying_dialog_visible = true;
  }
  //删除标签
  async deleteTag(id: number) {
    const res: any = await this.$axios.delete(`${API.delete_tag}/${id}`);
    if (res.status == 200) {
      this.$message.success('删除成功');
      // this.getSeedingList(this.table_data.current);
      return;
    }
  }
  onSelectChange(select_row_key: any, value: any) {
    this.select_row_key = select_row_key;
  }
  // 下载
  async download() {
    const custom_list = this.user_define_list
      .filter((item: any) => item.value)
      .map((item: any) => ({
        id: item.id,
        type: item.type == 1 ? 'text' : 'select',
        value: item.value || ''
      }));

    const send_data = {
      name: this.search_info_list.name.value,
      mobile: this.search_info_list.mobile.value,
      corp_name: this.search_info_list.corp_name.value,
      corp_position: this.search_info_list.corp_position.value,
      income_min: this.search_info_list.income.value.first,
      income_max: this.search_info_list.income.value.second,
      charge_teacher_id: this.search_info_list.charge_teacher_id.value,
      online_status: this.search_info_list.online_status.value,
      tag_id: this.getTagId().join(','),
      type_id: this.search_info_list.type.value,
      followup: this.search_info_list.followup.value,
      callback_time_start: this.search_info_list.callback_time.value[0] ? moment(this.search_info_list.callback_time.value[0]).startOf('days').unix() : undefined,
      callback_time_end: this.search_info_list.callback_time.value[1] ? moment(this.search_info_list.callback_time.value[1]).endOf('day').unix() : undefined,
      custom_list: encodeURIComponent(JSON.stringify(custom_list)),
      is_export: 1
    };
    console.log(send_data);

    const url = getUrl(API.get_seeding_list, send_data);
    // window.location.href = url;
    this.$axios.get(url).then((res) => {
      if (res.data.status === 200) {
        this.$message.info(res.data.data);
      } else {
        window.location.href = url;
      }
    });
  }
  // 按钮列表;
  btnClick(val: number) {
    switch (val) {
      case 1:
        if (this.select_row_key.length <= 0) return this.$message.error('请先勾选要批量修改的用户！');
        this.dialog_type = 1;
        this.dialog_title = '批量修改';
        this.modifying_dialog_visible = true;
        this.dialog_form_list = JSON.parse(JSON.stringify(seeding_modifying_list));
        this.dialog_form_list.forEach((item: any) => {
          if (item.key == 'charge_teacher_id') item.options = this.teacher_list.slice(1, this.teacher_list.length - 1);
          if (item.key == 'tag') item.bind.options = this.tag_list.filter((item: any) => item.type == 1);
          if (item.key == 'tag_chuang') item.bind.options = this.tag_list.filter((item: any) => item.type == 2);
          if (item.key == 'type_id') item.options = this.type_options;
        });

        break;
      case 2:
        this.user_define_dialog_visible = true;
        console.log(val);
        break;
      case 3:
        this.download();
        console.log(val);
        break;
      case 4:
        this.getSeedingList();
        this.select_row_key = [];
        break;
      case 5:
        Object.keys(this.search_info_list).forEach((key: any) => {
          if (this.search_info_list[key].key == 'income') {
            this.search_info_list[key].value.first = undefined;
            this.search_info_list[key].value.second = undefined;
          } else if (this.search_info_list[key].key == 'charge_teacher_id' || this.search_info_list[key].key == 'callback_time') {
            this.search_info_list[key].value = [];
          } else this.search_info_list[key].value = undefined;
        });
        this.user_define_list.forEach((element: any) => {
          element.value = null;
        });
        this.select_row_key = [];
        this.$forceUpdate();
        break;
      default:
        break;
    }
  }
  // 弹窗确认按钮
  async handleOk(list: any, type: number) {
    if (type == 1) {
      const tag = list.find((item: any) => item.key == 'tag')?.value || undefined;
      const send_data = {
        id: this.select_row_key,
        charge_teacher_id: list.find((item: any) => item.key == 'charge_teacher_id')?.value || undefined,
        tag: tag ? tag[tag.length - 1] : undefined,
        type_id: list.find((item: any) => item.key == 'type_id')?.value || undefined, // 创商跟进分类
        followup: list.find((item: any) => item.key == 'followup')?.value || undefined, // 创商跟进记录
        user_log: list.find((item: any) => item.key == 'user_log')?.value || undefined,
        cover_level: 0
      };
      const res: any = await this.$axios.put(`${API.edit_seeding_batch}`, send_data);
      if (res.status == 200) {
        this.$message.success('批量修改成功！');
      }
    } else {
      const tag = list.find((item: any) => item.key == 'tag')?.value || undefined;
      const send_data = {
        column: 'tag',
        value: tag ? tag[tag.length - 1] : undefined
      };
      const res = await this.$axios.put(`${API.edit_user_detail}/${this.select_tag_id}?menu_id=${(window as any).route_menu_id}`, send_data);
      if (res.status == 200) {
        this.$message.success('标签修改成功！');
        this.getSeedingList();
      }
    }
    this.getSeedingList(this.pagenation_info.current);
    this.dialog_form_list.forEach((item: any) => (item.value = undefined));

    this.modifying_dialog_visible = false;
    this.select_row_key = [];
  }
  // 表格input
  async addLog(item: any, type: string, id: number) {
    // if (item == '') return;
    const send_data = {
      id: [id],
      [type]: type === 'callback_time' ? moment(item).unix() || 0 : item,
      cover_level: 1
    };
    const res = await this.$axios.put(`${API.edit_seeding_batch}`, send_data);
    if (res.data.status !== 200) return this.$message.error('编辑失败！');
    this.$message.success('编辑成功！');
    this.getSeedingList(this.pagenation_info.current);
  }

  // 自定义字段编辑
  async userDefineTableValue(item: any, id: number) {
    // if (!item.custom_value) return;
    const res = await this.$axios.put(`${API.user_define}${id}`, item);
    if (res.data.status !== 200) return this.$message.error('编辑失败！');
    this.$message.success('编辑成功！');
    this.getSeedingList();
  }
  handleCancel(list: any, type: number) {
    this.modifying_dialog_visible = false;
    this.dialog_form_list.forEach((item: any) => (item.value = undefined));
    this.$forceUpdate();
  }
  async UserDefinedOk(list: any, type: number) {
    this.user_define_dialog_visible = false;
    const send_data: any = { channel: 1, add: [], edit: [] };
    list.forEach((element: any) => {
      if (element.type == 1) element.options = '';
      if (element.id) {
        send_data.edit.push(element);
      } else {
        send_data.add.push(element);
      }
    });
    const res = await this.$axios.put(API.edit_custom_config, send_data);
    if (res.status != 200 && res.data.status != 200) return this.$message.error('编辑失败！');
    this.$message.success('编辑成功！');
    this.getCustomConfig();
  }
  UserDefinedCancel(list: any, type: number) {
    this.user_define_dialog_visible = false;
  }
  // 切换分页
  async changePage(page: any) {
    this.pagenation_info.current = page.current;
    this.getSeedingList(page.current);
  }
  async created() {
    if (this.$route.query?.time) {
      this.search_info_list.callback_time.value = [moment(1451577600000), moment(Number(this.$route.query?.time) * 1000)];
      this.search_info_list.charge_teacher_id.value = this.teacher_list.filter((item: any) => this.$route.query?.name == item.charge)?.map((item: any) => item.id) || [];
    }

    await this.getCustomConfig();
    await this.getSeedingList();
    this.getSeedingType();
    console.log(this.search_info_list);

    this.search_info_list.charge_teacher_id.options = this.teacher_list;
    this.search_info_list.tag_id.bind.options = this.tag_list.filter((item: any) => item.type == 1);
    this.search_info_list.tag_id_chuang.bind.options = this.tag_list.filter((item: any) => item.type == 2);
    const arr = ['黄茜', '雷媛媛'];
    if (localStorage['master:profile']) {
      if (!arr.includes(JSON.parse(localStorage['master:profile']).data.name)) {
        this.btn_list = this.btn_list.filter((item: any) => item.id != 2);
      }
    }
    if (localStorage['beta:profile']) {
      if (!arr.includes(JSON.parse(localStorage['beta:profile']).data.name)) {
        this.btn_list = this.btn_list.filter((item: any) => item.id != 2);
      }
    }
  }
  editModal(record: any) {
    this.record = record;
    this.text = record.chuang_user.followup;
    this.show_text_modal = true;
  };
  confirmEdit() {
    this.addLog(this.text, 'followup', this.record.id)
    this.show_text_modal = false;
  }
}
